import { ReactComponent as PeopleIcon } from '../assets/icons/groups.svg';
import { ReactComponent as NewsIcon } from '../assets/icons/topic-icon.svg';
import { ReactComponent as LegalsIcon } from '../assets/icons/insert_drive_file.svg';
import { ReactComponent as GeneralIcon } from '../assets/icons/event_note.svg';
import { primaryPalette } from '../styles/theme';

export const ANNOUNCEMENT_CATEGORY = {
  SOCIAL: 'SOCIAL',
  NEWS: 'NEWS',
  LEGAL: 'LEGAL',
  GENERAL: 'GENERAL',
};

export const ANNOUNCEMENT_CATEGORY_KEYS = Object.values(ANNOUNCEMENT_CATEGORY);

export const ANNOUNCEMENT_CATEGORY_TYPES = {
  [ANNOUNCEMENT_CATEGORY.SOCIAL]: {
    color: primaryPalette.blue1,
    backgroundColor: primaryPalette.blue11,
    icon: PeopleIcon,
  },
  [ANNOUNCEMENT_CATEGORY.NEWS]: {
    color: primaryPalette.green1,
    backgroundColor: primaryPalette.green16,
    icon: NewsIcon,
  },
  [ANNOUNCEMENT_CATEGORY.LEGAL]: {
    color: primaryPalette.orange,
    backgroundColor: primaryPalette.yellow4,
    icon: LegalsIcon,
  },
  [ANNOUNCEMENT_CATEGORY.GENERAL]: {
    color: primaryPalette.purple,
    backgroundColor: primaryPalette.blue10,
    icon: GeneralIcon,
  },
};

export const ANNOUNCEMENTS_PAGE_SIZE = 5;

export const ANNOUNCEMENT_FORM_FIELD_NAMES = {
  CATEGORY: 'category',
  TITLE: 'title',
  BODY: 'body',
  IS_PUBLISHED: 'is_published',
  ATTACHMENT: 'attachment',
};

export const ANNOUNCEMENT_ATTACHMENT_MAX_SIZE = 5 * 1024 ** 2;

export const ANNOUNCEMENT_ATTACHMENT_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/csv',
];

export const ANNOUNCEMENT_ATTACHMENT_TYPES = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'text/csv': ['.csv'],
};
